import {
  createFolder,
  renameFile,
  deleteFile,
  duplicateFile,
  shareList,
  deleteQuoteSet,
  updateQuoteSet,
  moveFile,
} from '../thunks/file';
import { handlePending, handleRejected } from './utils';

export const fileReducers = (builder) => {
  // Create folder
  builder
    .addCase(createFolder.fulfilled, (state, action) => {
      const items = [...state.items.value];
      items.push({ ...action.payload, access: ['Read', 'Write'] });
      state.items.value = items;
      state.fileForm.loading = false;
    })
    .addCase(createFolder.pending, (state) => handlePending(state, 'fileForm'))
    .addCase(createFolder.rejected, (state) => handleRejected(state, 'fileForm'));

  // Rename folder or file
  builder
    .addCase(renameFile.fulfilled, (state, action) => {
      const items = [...state.items.value];
      const updatedFile = action.payload;
      state.selectedFile = updatedFile;
      const index = items.findIndex((item) => item.id === updatedFile.id);
      if (index !== -1) {
        items[index] = updatedFile;
        state.items.value = items;
      }
      state.fileForm.loading = false;
    })
    .addCase(renameFile.pending, (state) => handlePending(state, 'fileForm'))
    .addCase(renameFile.rejected, (state) => handleRejected(state, 'fileForm'));

  // Delete folder or file
  builder.addCase(deleteFile.fulfilled, (state, action) => {
    const id = action.payload;
    const items = [...state.items.value];
    const index = items.findIndex((item) => item.oid === id);
    if (index !== -1) {
      items.splice(index, 1);
    }
    state.items.value = items;
  });

  // Delete quote set file
  builder.addCase(deleteQuoteSet.fulfilled, (state, action) => {
    const id = action.payload;
    const items = [...state.items.value];
    const index = items.findIndex((item) => item.oid === id);
    if (index !== -1) {
      items.splice(index, 1);
    }
    state.items.value = items;
  });

  // Rename quote set file
  builder
    .addCase(updateQuoteSet.fulfilled, (state, action) => {
      const items = [...state.items.value];
      const updatedFile = action.payload;
      state.selectedFile = updatedFile;
      const index = items.findIndex((item) => item.oid === updatedFile.id);
      if (index !== -1) {
        items[index] = { ...items[index], ...updatedFile };
        state.items.value = items;
      }
      state.fileForm.loading = false;
    })
    .addCase(updateQuoteSet.pending, (state) => handlePending(state, 'fileForm'))
    .addCase(updateQuoteSet.rejected, (state) => handleRejected(state, 'fileForm'));

  // Duplicate folder or file
  builder.addCase(duplicateFile.fulfilled, (state, action) => {
    const { parent } = action.meta.arg;
    const items = [...state.items.value];

    if (parent) {
      items.push(action.payload);
      state.items.value = items;
    }
  });

  // Share list (people who has access in the file)
  builder.addCase(shareList.fulfilled, (state, action) => {
    state.shareList.loading = false;
    state.shareList.value = action.payload;
  });

  //Move file
  builder.addCase(moveFile.fulfilled, (state, action) => {
    const { isUndo } = action.meta.arg;
    const items = [...state.items.value];

    if (isUndo && action.payload.parent === state.activeFolder) {
      const exists = state.items.value.some((item) => item.id === action.payload.id);
      if (!exists) state.items.value.unshift(action.payload);
      return;
    }

    const id = action.payload.id;
    const index = items.findIndex((item) => item.id === id);
    if (index !== -1) {
      items.splice(index, 1);
    }
    state.items.value = items;
  });
};
